import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';

import FlowStepQuestion from './FlowStepQuestion';
import { useFlowContext } from '../FlowContext';

const styles = theme => ({
  root: {},
  question: {
    paddingTop: theme.spacing(4),
  },
});

const FlowStep = ({
  className,
  classes,
}) => {
  const { flowCollection, currentStepIndex, currentStep } = useFlowContext();

  return (
    <div
      className={classNames(classes.root, className)}
    >
      {currentStep.attr('questions').resources().list().map((questionResource) => {
        return (
          <FlowStepQuestion
            className={classes.question}
            key={questionResource.link('self').url()}
            flowCollection={flowCollection}
            currentStepIndex={currentStepIndex}
            questionResource={questionResource}
          />
        );
      })}
    </div>
  );
};

FlowStep.defaultProps = {
  className: '',
};

FlowStep.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(FlowStep);
